import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Dispatch } from 'react-redux';
import { ITranslateProps } from 'models/common';
import { LoadingOverlayWrapper } from 'components/Loader';
import renderIcon, { IconName } from 'helpers/renderIcon';
import { Link, RouteComponentProps } from 'react-router';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { formatCurrency } from 'helpers/common';
import moment = require('moment');
import { DiscountStrategyType, IDiscountStrategy } from 'models/shop/discountStrategies';
import {
	addEditBatchDiscountStrategies,
	deleteDiscountStrategyGroup,
	getDiscountStrategies,
} from 'redux/modules/shop/discountStrategies';
import { ErrorSummary } from 'components';
import { DropdownModal } from 'components/Common/DropdownModal';
import { actions as notifActions } from 'redux-notifications';
import { momentWithTimezone } from 'redux/modules/shop/helpers';

require('./style.scss');

interface IParams {
	shopId: string;
}

interface IOwnProps extends RouteComponentProps<IParams, {}> {}

interface IProps
	extends IOwnProps,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {}

interface IState {
	sorting: string;
	discountGroupsSorted: string[];
	searchPromoText: string;
}
const mapStateToProps = (state: IStore) => ({
	shopCard: state.shopcard.shopcard,
	entireShopCard: state.shopcard,
	discountStrategies: state.discountStrategyReducer,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	getShopCard: () => dispatch(getShopCard(ownProps.params.shopId, false, true)),
	getDiscountStrategies: (shopId) => dispatch(getDiscountStrategies(shopId)),
	addEditBatchDiscountStrategies: (discountStrategies, groupId) =>
		dispatch((dispatch, getState) =>
			addEditBatchDiscountStrategies(dispatch, getState, ownProps.params.shopId, discountStrategies, groupId),
		),
	deleteDiscountStrategyGroup: (groupId) =>
		dispatch((dispatch, getState) => deleteDiscountStrategyGroup(dispatch, getState, ownProps.params.shopId, groupId)),
	showNotification: (message: string, kind: string, dismissAfter = 3000) =>
		dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
});

export enum DiscountTagType {
	active = 'Active',
	inactive = 'Inactive',
}

export const discountTypeIcons: { [key: number]: IconName } = {
	[DiscountStrategyType.LimitedTimeOffer]: 'lightning',
	[DiscountStrategyType.PromoCode]: 'coupon',
};

const formatTime = (date: moment.Moment) => date.format('LL');

export const renderDiscountTag = (t: ITranslateProps['t'], type: DiscountTagType) => {
	return <span className={`discountTag ${type}`}>{t(`Shop_Promotions_DiscountTag_${type}`)}</span>;
};

const sortingFunctions: { [key: string]: (a: IDiscountStrategy, b: IDiscountStrategy) => number } = {
	CreatedNewer: (a, b) => (moment(b.addedDate).isBefore(moment(a.addedDate)) ? -1 : 1),
	CreatedOlder: (a, b) => (moment(b.addedDate).isBefore(moment(a.addedDate)) ? 1 : -1),
	Name: (a, b) => a.title.localeCompare(b.title),
	NameRev: (a, b) => b.title.localeCompare(a.title),
	StartDateOlder: (a, b) => (moment(b.validFrom).isBefore(moment(a.validFrom)) ? 1 : -1),
	StartDateNewer: (a, b) => (moment(b.validFrom).isBefore(moment(a.validFrom)) ? -1 : 1),
	EndDateOlder: (a, b) => (moment(b.validTo).isBefore(moment(a.validTo)) ? 1 : -1),
	EndDateNewer: (a, b) => (moment(b.validTo).isBefore(moment(a.validTo)) ? -1 : 1),
};

const renderDiscountGroupComponent = (
	t: ITranslateProps['t'],
	groupId,
	discountGroupItem: IDiscountStrategy,
	currencyKey,
	shopId,
	setGroupActive: (dgid: string, status) => void,
	deleteGroup: (dgid: string) => void,
	timezone: string,
) => {
	const tagType = discountGroupItem.isActive ? DiscountTagType.active : DiscountTagType.inactive;

	const discountStr = discountGroupItem.isDiscountPercentage
		? discountGroupItem.discountValue + '%'
		: formatCurrency(currencyKey, discountGroupItem.discountValue);

	return (
		<Link to={`/shop/${shopId}/view/promo/${groupId}`} key={groupId} className="discountGroupCard">
			<div className="header">
				<div className="left-content">
					<div className="d-flex flex-row justify-content-center align-items-center">
						{renderIcon(discountTypeIcons?.[discountGroupItem?.type], 24, 24)}
						<h2>{discountGroupItem.title}</h2>
					</div>
					{renderDiscountTag(t, tagType)}
				</div>
				<div className="right-content">
					<DropdownModal buttonComponent={renderIcon('moreVerticalGray', 24, 24)} stopPropagation={true}>
						<Link to={`/shop/${shopId}/edit/promo/${groupId}`}>{t('Shop_Promotions_Dropdown_Edit')}</Link>
						<Link to={`/shop/${shopId}/duplicate/promo/${groupId}`}>{t('Shop_Promotions_Dropdown_Duplicate')}</Link>
						<div onClick={() => setGroupActive(groupId, !discountGroupItem.isActive)}>
							{t('Shop_Promotions_Dropdown_' + (discountGroupItem.isActive ? 'Deactivate' : 'Activate'))}
						</div>
						<div onClick={() => deleteGroup(groupId)} className="red">
							{t('Shop_Promotions_Dropdown_Delete')}
						</div>
					</DropdownModal>
				</div>
			</div>
			<div className="body">
				<p className="description">
					{t(`Shop_Promotions_DiscountType_${discountGroupItem.type}`)},{` ${discountStr} `}
					{/*eslint-disable-next-line no-constant-condition*/}
					{true ? t('Shop_Promotions_DiscountOnSelectedServices') : t('Shop_Promotions_DiscountOnAllServices')}
				</p>
				<p className="dateRange">
					<span>{`${formatTime(momentWithTimezone(timezone, discountGroupItem.validFrom))} - ${formatTime(
						momentWithTimezone(timezone, discountGroupItem.validTo),
					)}`}</span>
				</p>
			</div>
		</Link>
	);
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SalesPromotionsForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			sorting: 'CreatedNewer',
			discountGroupsSorted: undefined,
			searchPromoText: '',
		};

		this.fetchData = this.fetchData.bind(this);
		this.setGroupActive = this.setGroupActive.bind(this);
		this.deleteGroup = this.deleteGroup.bind(this);
	}

	componentDidMount(): void {
		this.fetchData();
	}

	componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): void {
		this.fetchData(prevProps, prevState);
	}

	private fetchData(prevProps?: Readonly<IProps>, prevState?: Readonly<IState>) {
		if (
			(!this.props.shopCard || this.props.shopCard?.id != this.props.params.shopId) &&
			!this.props.entireShopCard.isFetching &&
			!this.props.entireShopCard.error
		) {
			this.props.getShopCard();
		}

		if (
			(!this.props.discountStrategies.groupedDiscountStrategies ||
				this.props?.discountStrategies.shopId != this.props.params.shopId) &&
			!this.props.discountStrategies.error &&
			!this.props.discountStrategies.isFetching
		) {
			this.props.getDiscountStrategies(this.props.params.shopId);
		}

		if (
			this.props?.discountStrategies?.groupedDiscountStrategies &&
			!this.props?.discountStrategies?.isFetching &&
			this.props?.discountStrategies.shopId == this.props.params.shopId &&
			(!this.state.discountGroupsSorted ||
				prevState.sorting != this.state.sorting ||
				prevState.searchPromoText != this.state.searchPromoText ||
				JSON.stringify(Object.keys(this.props?.discountStrategies?.groupedDiscountStrategies || {})) !=
					JSON.stringify(Object.keys(prevProps?.discountStrategies?.groupedDiscountStrategies || {})))
		) {
			const searchStr = this.state.searchPromoText;
			const discountGroups = this.props.discountStrategies.groupedDiscountStrategies;
			let discountGroupsSorted = Object.keys(discountGroups);
			discountGroupsSorted = discountGroupsSorted
				.filter((dg) => discountGroups[dg]?.[0].title?.toLowerCase()?.includes(searchStr?.toLowerCase()))
				.sort((a, b) => sortingFunctions[this.state.sorting](discountGroups[a]?.[0], discountGroups[b]?.[0]));

			this.setState({ discountGroupsSorted });
		}
	}

	private setGroupActive(groupId: string, status) {
		const discountGroup = this.props.discountStrategies?.groupedDiscountStrategies?.[groupId];
		if (discountGroup)
			this.props
				.addEditBatchDiscountStrategies(
					discountGroup.map((d) => ({ ...d, isActive: status })),
					groupId,
				)
				.then(() => {
					this.props.showNotification(this.props.t('Shop_Promotions_SavedSuccessfully'), 'success');
				})
				.catch((e) => {
					this.props.showNotification(e, 'error');
				});
	}

	private deleteGroup(groupId: string) {
		this.props
			.deleteDiscountStrategyGroup(groupId)
			.then(() => {
				this.props.showNotification(this.props.t('Shop_Promotions_SavedSuccessfully'), 'success');
			})
			.catch((e) => {
				this.props.showNotification(e, 'error');
			});
	}

	render() {
		const { shopCard, t, discountStrategies } = this.props;
		const discountGroups = discountStrategies.groupedDiscountStrategies || {};
		const discountGroupArr = this.state.discountGroupsSorted || [];

		return (
			<div className="editPromotionsContainer container d-flex flex-row justify-content-center">
				<div className="promotions">
					<LoadingOverlayWrapper
						className="subsection-main"
						active={this.props.entireShopCard?.isFetching || this.props.discountStrategies?.isFetching}
					>
						<div className="headerContainer">
							<h1>{t('Shop_Promotions_Title')}</h1>
							<Link to={`/shop/${this.props.params.shopId}/new/promo/0`} className="headerButton createNewButton">
								{renderIcon('nikaPlus', 20, 20)}
								<span className="createNewButtonText">{t('Shop_Promotions_CreateNew')}</span>
							</Link>
						</div>
						<div className="headerSection">
							<div className="inputHolder searchPromotions">
								{renderIcon('search1', 16, 16)}
								<input
									placeholder={t('Shop_Promotions_SearchPromotions')}
									onChange={(ev) => this.setState({ searchPromoText: ev.target.value })}
									value={this.state.searchPromoText}
								/>
							</div>
							<DropdownModal
								className="headerButton sortButton"
								buttonComponent={
									<>
										{renderIcon('upDownArrows', 20, 20)}
										<span className="sortButtonText">
											{t(`Shop_Promotions_Sorting_${this.state.sorting}`).split(' (')?.[0]}
										</span>
									</>
								}
							>
								{Object.keys(sortingFunctions).map((fnname) => (
									<div onClick={() => this.setState({ sorting: fnname })} key={fnname}>
										{t(`Shop_Promotions_Sorting_${fnname}`)}
									</div>
								))}
							</DropdownModal>
						</div>
						{(!shopCard || !discountGroupArr?.length) &&
							(this.state.searchPromoText?.length ? (
								<div className="missingNotice">
									<h2>{t('Shop_Promotions_SearchNoPromotions_Title')}</h2>
									<p>{t('Shop_Promotions_SearchNoPromotions_Desc')}</p>
								</div>
							) : (
								<div className="missingNotice">
									<h2>{t('Shop_Promotions_NoPromotions_Title')}</h2>
									<p>
										<Link to={`/shop/${this.props.params.shopId}/new/promo/0`}>
											{t('Shop_Promotions_NoPromotions_Desc_Clickable')}
										</Link>{' '}
										{t('Shop_Promotions_NoPromotions_Desc_Suffix')}
									</p>
								</div>
							))}
						{shopCard && (
							<div className="salesCards">
								{discountGroupArr.map(
									(groupId) =>
										discountGroups[groupId]?.[0] &&
										renderDiscountGroupComponent(
											t,
											groupId,
											discountGroups[groupId][0],
											shopCard?.currencyKey,
											shopCard?.id,
											this.setGroupActive,
											this.deleteGroup,
											shopCard?.offices?.find((of) => of.id == discountGroups[groupId][0]?.officeId)?.zoneInfo,
										),
								)}
							</div>
						)}
						<ErrorSummary error={this.props.discountStrategies.error} message={this.props.discountStrategies.message} />
						<ErrorSummary error={this.props.entireShopCard.error} message={this.props.entireShopCard.message} />
					</LoadingOverlayWrapper>
				</div>
			</div>
		);
	}
}

const SalesPromotions = connect(mapStateToProps, mapDispatchToProps)(SalesPromotionsForm);

export { SalesPromotions };
